import Coverage from './Coverage';

export default Coverage;
